// src/sections/AboutUs/AboutUs.tsx
import React, { useEffect, useRef, useState } from "react";
import elenoitillus from "../assets/img/elenoit-illustrator.png";
import about from "../../../assets/img/about.jpg";
import choose_1 from "../assets/img/choose-1.jpg";
import choose_2 from "../assets/img/choose-2.jpg";
import bannerBg from "../assets/img/banner-bg.jpg";

import { AboutUsData } from "../AboutUs/AboutUsData";

interface AboutUsProps {
  id: string;
}

const AboutUs: React.FC<AboutUsProps> = ({ id }) => {
  const [expandedTestimonial, setExpandedTestimonial] = useState(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [counts, setCounts] = useState(AboutUsData.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounts();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCounts = () => {
    const duration = 2000;
    const frameRate = 16;
    const totalFrames = Math.round(duration / frameRate);

    const targetNumbers = AboutUsData.map(
      (stat) => parseInt(stat.number.replace(/\D/g, "")) // Extract numeric part
    );
    const increments = targetNumbers.map((num) => num / totalFrames);

    let frame = 0;
    const interval = setInterval(() => {
      frame++;
      setCounts((prev) =>
        prev.map((count, i) => {
          const nextVal = Math.ceil(frame * increments[i]);
          return nextVal >= targetNumbers[i] ? targetNumbers[i] : nextVal;
        })
      );

      if (frame >= totalFrames) {
        clearInterval(interval);
      }
    }, frameRate);
  };
  return (
    <section id={id} className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h6 className="text-blue-600 font-semibold text-lg">
                About Our Company
              </h6>
              <h2 className="text-2xl font-bold text-gray-900">
                Providing Your Business With a Quality IT Service is Our
                Passion.
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                We Provide IT Software Development and Digital Marketing
                Consulting Services that offer a holistic platform to digitally
                transform and empower businesses with cutting-edge technologies.
                We are your trusted partner in carving out the roadmap of your
                business from strategy to execution.
              </p>
            </div>

            {/* Skills Progress */}
            <div className="space-y-6">
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-gray-700">
                    IT Consulting
                  </span>
                  <span className="text-purple-600 font-bold">90%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div
                    className="bg-purple-600 h-1 rounded-full"
                    style={{ width: "90%" }}
                  ></div>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-gray-700">
                    Digital Marketing
                  </span>
                  <span className="text-purple-600 font-bold">90%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div
                    className="bg-purple-600 h-1 rounded-full"
                    style={{ width: "90%" }}
                  ></div>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-gray-700">
                    Managed IT Service
                  </span>
                  <span className="text-purple-600 font-bold">80%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div
                    className="bg-purple-600 h-1 rounded-full"
                    style={{ width: "80%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="text-center absolute bottom-20 left-1">
              <div
                className="
        absolute left-[-25px] bottom-[25px]
        text-left
        py-5 px-10
        bg-white
        border-b-2 border-solid border-orange-primary
        shadow-xl-custom
        z-10
      "
              >
                <div
                  className="
        text-6xl font-bold mb-2
        bg-gradient-to-r from-gradient-start-orange to-gradient-end-orange
        text-transparent bg-clip-text
        inline-block {/* Needed for bg-clip-text to work well */}
      "
                >
                  12+
                </div>
                <span
                  className="
        text-s font-semibold text-orange-primary uppercase tracking-wide
        whitespace-nowrap {/* <--- ADDED THIS CLASS */}
      "
                >
                  Years Experience
                </span>
              </div>
            </div>
            <div>
              <img src={about} alt="About our company" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
